<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          
          <v-card-title>
            Weekly Overview
            <v-spacer></v-spacer>
            <v-btn icon @click="prevWeek">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon @click="nextWeek">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="selectedDate"
                  label="Select Week"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedDate"
                :show-current="true"
                @change="fetchWeekData"
                first-day-of-week="1"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="weekData"
              item-key="day"
              class="elevation-1"
              hide-default-footer
              :item-class="(item) => item.day === 'Total' ? 'total-row' : ''"
            >
              
            </v-data-table>
          </v-card-text>
          <v-row>
                  <v-col>
                    <v-card-text>
                      <strong>Balance Carried Forward: {{ balanceCarriedForward }}</strong>
                    </v-card-text>
                  </v-col>
                  <v-col>
                    <v-card-text>
                      <strong>Cumulative Total: {{ cumulativeTotal }}</strong>
                    </v-card-text>
                  </v-col>
                </v-row>
        </v-card>
                
      </v-col>
    </v-row>
    <br>
    <monthy-total :id="id"></monthy-total>
  </v-container>
</template>

<script>
import { axios } from '../../../utils';
import MonthyTotal from './MonthyTotal.vue';

export default {
  components: { MonthyTotal },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      weekData: [],
      headers: [
        { text: 'Day', value: 'day' },
        { text: 'Calls', value: 'total_calls' },
        { text: 'Total Appointments', value: 'total_appointments' },
        { text: 'Total Presentations', value: 'total_presentations' },
        { text: 'Total Sales', value: 'total_sales' },
        { text: 'Price North', value: 'price_north' },
        { text: 'Price East', value: 'price_east' },
        { text: 'Price West', value: 'price_west' },
        { text: 'Price South', value: 'price_south' },
        { text: 'Total Price', value: 'total_price' },
      ],
      menu: false,
      selectedDate: '', // Set later in mounted
      balanceCarriedForward: 0, // Initialize balance carried forward
      cumulativeTotal: 0, // Initialize cumulative total
    };
  },
  mounted() {
    this.setPreviousWeekStartDate();
    this.fetchWeekData();
  },
  methods: {
    async fetchWeekData() {
      try {
        const startOfWeek = this.getStartOfWeek(this.selectedDate);
        const response = await axios.get('api/admin/phone-calls/week-overall', {
          params: { start_date: startOfWeek, id: this.id },
        });
        console.log(response.data, 'from fetchweekdata', typeof response.data)
        this.weekData = this.processData(response.data);
      } catch (error) {
        console.error('Error fetching weekly data:', error);
      }
    },
    processData(data) {
      this.balanceCarriedForward = data.balance_cf;
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
      let processedData = [];

      // Variables to store the totals for the week
      let totalCallsWeek = 0;
      let totalAppointmentsWeek = 0;
      let totalPresentationsWeek = 0;
      let totalSalesWeek = 0;
      let totalNorthWeek = 0;
      let totalEastWeek = 0;
      let totalWestWeek = 0;
      let totalSouthWeek = 0;
      let totalPriceWeek = 0;

      days.forEach((day, index) => {
        // Convert the object data into an array of its values
        const dataArray = Object.values(data);

        let dayData = dataArray
          .flatMap(array => array) // Flatten the array
          .filter(d => d && new Date(d.date).getDay() === (index + 1));
        // Check if dayData is not an empty array
        if (dayData.length > 0) {
          // Initialize variables to store region totals
          let totalNorth = 0;
          let totalEast = 0;
          let totalWest = 0;
          let totalSouth = 0;

          // Iterate over each object in dayData
          dayData.forEach(dayItem => {
            if (dayItem.region_totals) {
              // Update region totals only if region_totals exists
              totalNorth += dayItem.region_totals['North'] || 0;
              totalEast += dayItem.region_totals['East'] || 0;
              totalWest += dayItem.region_totals['West'] || 0;
              totalSouth += dayItem.region_totals['South'] || 0;
            }
          });

          const totalCalls = dayData.reduce((acc, curr) => acc + (curr.total_calls || 0), 0);
          const totalAppointments = dayData.reduce((acc, curr) => acc + (curr.total_appointments || 0), 0);
          const totalPresentations = dayData.reduce((acc, curr) => acc + (curr.total_presentations || 0), 0);
          const totalSales = dayData.reduce((acc, curr) => acc + (curr.total_sales || 0), 0);
          const totalPrice = totalNorth + totalEast + totalWest + totalSouth;

          // Update the weekly totals
          totalCallsWeek += totalCalls;
          totalAppointmentsWeek += totalAppointments;
          totalPresentationsWeek += totalPresentations;
          totalSalesWeek += totalSales;
          totalNorthWeek += totalNorth;
          totalEastWeek += totalEast;
          totalWestWeek += totalWest;
          totalSouthWeek += totalSouth;
          totalPriceWeek += totalPrice;

          // Push object with aggregated values into processedData
          processedData.push({
            day,
            total_calls: totalCalls,
            total_appointments: totalAppointments,
            total_presentations: totalPresentations,
            total_sales: totalSales,
            price_north: totalNorth,
            price_east: totalEast,
            price_west: totalWest,
            price_south: totalSouth,
            total_price: totalPrice,
          });
        } else {
          // If dayData is empty, push default values
          processedData.push({
            day,
            total_calls:0,
            total_appointments: 0,
            total_presentations: 0,
            total_sales: 0,
            price_north: 0,
            price_east: 0,
            price_west: 0,
            price_south: 0,
            total_price: 0,
          });
        }
      });

      // Add the total row for the week
      processedData.push({
        day: 'Total',
        total_calls: totalCallsWeek,
        total_appointments: totalAppointmentsWeek,
        total_presentations: totalPresentationsWeek,
        total_sales: totalSalesWeek,
        price_north: totalNorthWeek,
        price_east: totalEastWeek,
        price_west: totalWestWeek,
        price_south: totalSouthWeek,
        total_price: totalPriceWeek,
      });
      this.cumulativeTotal = this.balanceCarriedForward + totalPriceWeek;
      return processedData;
    },
    getStartOfWeek(date) {
      const currentDate = new Date(date);
      const firstDayOfWeek = currentDate.getDate() - currentDate.getDay() + (currentDate.getDay() === 0 ? -6 : 1); // Adjust if Sunday
      const startOfWeek = new Date(currentDate.setDate(firstDayOfWeek));
      return startOfWeek.toISOString().substr(0, 10);
    },
    setPreviousWeekStartDate() {
      const today = new Date();
      const dayOfWeek = today.getDay(); // Get the current day of the week
      const diffToMonday = (dayOfWeek === 0 ? 6 : dayOfWeek - 1); // Calculate the difference to Monday
      const previousMonday = new Date(today.setDate(today.getDate() - diffToMonday - 7)); // Get last week's Monday
      this.selectedDate = previousMonday.toISOString().substr(0, 10); // Set the selected date to the previous week's Monday
    },
    prevWeek() {
      const currentDate = new Date(this.selectedDate);
      currentDate.setDate(currentDate.getDate() - 7);
      this.selectedDate = currentDate.toISOString().substr(0, 10);
      this.fetchWeekData();
    },
    nextWeek() {
      const currentDate = new Date(this.selectedDate);
      currentDate.setDate(currentDate.getDate() + 7);
      this.selectedDate = currentDate.toISOString().substr(0, 10);
      this.fetchWeekData();
    }
  }
};
</script>

<style>
.total-row {
  font-weight: bold;
  background-color: #f5f5f5;
}
</style>
